import Vue from "vue";
import VueGtag from "vue-gtag";
import App from "./App.vue";

import router from "./router";

Vue.config.productionTip = false;

Vue.use(VueGtag, {
  config: { id: "UA-113062608-1" }
}, router);

new Vue({
  router,
  render: h => h(App),
  mounted() {
    console.log(`%cVersion: ${process.env.VUE_APP_GITHASH}`, "background: #222; color: #bada55");
  }
}).$mount("#app");
